import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/vi';
import vi_VN from 'antd/es/locale/vi_VN';
import en_US from 'antd/es/locale/en_US';
import viTranslations from '../lang/vi.json';
import enTranslations from '../lang/en.json';

const getStoredLanguage = () => {
  try {
    return localStorage.getItem('language') || 'vi';
  } catch (e) {
    return 'vi';
  }
};

const normalizeLanguage = (lang) => {
  return String(lang || '').toLowerCase().startsWith('vi') ? 'vi' : 'en';
};

const getUiLocale = () => {
  return normalizeLanguage(i18next.language) === 'vi' ? 'vi-VN' : 'en-US';
};

const getAntdLocale = () => {
  return normalizeLanguage(i18next.language) === 'vi' ? vi_VN : en_US;
};

const applyDateLocales = (lang) => {
  moment.locale(normalizeLanguage(lang) === 'vi' ? 'vi' : 'en');
};

const setupI18n = async (defaultLanguage = getStoredLanguage()) => {
  const language = normalizeLanguage(defaultLanguage);
  await i18next.use(initReactI18next).init({
    lng: language,
    fallbackLng: false,
    resources: {
      vi: {
        translation: viTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });
  applyDateLocales(language);
};


const setLanguage = async (language) => {
  if (!language) {
    language = 'vi'
  }
  language = normalizeLanguage(language);
  await i18next.changeLanguage(language);
  localStorage.setItem('language', language);
  applyDateLocales(language);
};

setupI18n();

export {
  i18next as I18n,
  setLanguage,
  normalizeLanguage,
  getUiLocale,
  getAntdLocale,
};
